// ---- Debug ----
const url_debug = "http://localhost:57844"
//const url_debug = 'http://192.168.10.10'        // Intranet
//const url_debug = 'http://192.168.10.10:1325'   // Intranet test
//const url_debug = 'http://79.9.230.202'           // Internet   
//const url_debug = 'http://79.9.230.202:1325'    // Internet test

const url_debugImg = "http://79.9.230.202:1325"

const urlPrivacy = "https://areariservata.manuellodesign.it/UserFile/privacy/privacy.pdf"
const urlDocumenti = "https://areariservata.manuellodesign.it/UserFile/LISTINIPERDOWNLOAD/"

export default {

  getUrl() {
    if (window.location.host.includes("localhost"))
      return url_debug

    return window.location.protocol + "//" + window.location.host
  },

  getUrlApi() {

    let url = this.getUrl();

    if (url.includes("localhost"))
      url += ""
    else
      url += "/api"

    return url
  },


  getUrlDownload() {
    return urlDocumenti
  },

  getUrlPrivacy() {
    return urlPrivacy
  },

  getUrlImg() {

    let url = this.getUrl();

    // NOTA: se uso il localhost, devo agganciare le immagini dal server
    if (url.includes("localhost"))
      url = url_debugImg

    url += "/UserFile/img"

    return url
  },


  getUrlUserFile() {

    let url = this.getUrl();

    url += "/UserFile"

    return url
  },


  getUrl_Update() {

    let url = this.getUrl();

    if (window.location.host.includes("localhost"))
      url = ""
    else
      url += "/index.html"

    return url
  }


}